export default "__VITE_ASSET__Db39r1o1__"